import { Pipe, PipeTransform } from '@angular/core';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';

@Pipe({
  name: 'datez',
  standalone: false,
})
export class DatezPipe implements PipeTransform {
  private currentYear: number = new Date().getFullYear();
  private dateObject: any;
  private formatted: string;

  constructor() {
    dayjs.extend(utc);
    dayjs.extend(dayjsTimezone);
  }

  public transform(
    date: string | number | Date,
    timezone: string,
    format?: string,
    formatWithYear?: string
  ): string {
    if (date === undefined || date === null) {
      return;
    }

    this.dateObject = timezone ? dayjs(date).tz(timezone) : dayjs(date);

    // Update this.formatted with the appropriate date format
    this.handleFormats(format, formatWithYear);

    return this.formatted;
  }

  private handleFormats(f: string, fYr: string) {
    if (this.dateObject.year() !== this.currentYear) {
      const yearFormat = fYr || f || 'MMM D, YYYY h:mma';
      this.formatted = this.dateObject.format(yearFormat);
    } else {
      this.formatted = this.dateObject.format(f || 'MMM D h:mma');
    }
  }
}
